/**
 * Ajax统一后端接口请求入口
 * Created by Administrator on 2018/6/25.
 */

import axios from 'axios';
import Common from '@/utils/common';
import jQuery from 'jquery';

const service = {};
service.requestCount = 0;
window.FRONT_HOST = process.env.FRONT_HOST;
window.SERVER_BASE = `${process.env.SERVER_API}/`;

window.SERVER_BRC_BASE = `${process.env.SERVER_BRC_API}/`;

service.serverUrl = window.SERVER_BASE;
axios.defaults.timeout = 200000;                // 响应时间
// axios.defaults.baseURL = window.SERVER_BASE;   // 配置接口地址
axios.defaults.withCredentials = true;
axios.defaults.responseType = 'json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.get['Cache-Control'] = 'no-cache';
axios.defaults.headers.get.Pragma = 'no-cache';
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.withCredentials = true;
/**
 * 不使用加载器的请求地址
 * @type {string[]}
 */
service.NO_LOADING_URLS = [

];

/**
 * 遮罩层的展现或者隐藏
 * @param isShow
 */
service.preloaderDisplay = function (config, isShow) {
  let reqUrl = config.url;
  if (config.url.startsWith(config.baseURL)) {
    reqUrl = config.url.substr(config.baseURL.length - 1);
  }
  for (const noLoadingUrl of service.NO_LOADING_URLS) {
    if (reqUrl.startsWith(noLoadingUrl)) {
      return;
    }
  }

  if (isShow) {
    service.requestCount += 1;
    Common.Preloader.show();
  } else {
    service.requestCount -= 1;
    if (service.requestCount <= 0) {
      service.requestCount = 0;
      Common.Preloader.hidden();
    }
  }
};

/**
 * 全局请求拦截器，计算当前请求数量，并展现遮罩层
 */
axios.interceptors.request.use((config) => {
  service.preloaderDisplay(config, true);
  return config;
}, (error) => {
  service.preloaderDisplay(error.config, false);
  return Promise.reject(error);
});

/**
 * 全局响应拦截器，计算当前请求数量，请求量为0后隐藏遮罩层
 */
axios.interceptors.response.use((response) => {
  service.preloaderDisplay(response.config, false);
  return response;
}, (error) => {
  service.preloaderDisplay(error.config, false);
  return Promise.reject(error);
});

/**
 * 处理响应失败时的提示消息
 * @param response
 * @returns {string}
 */
service.getFailedResponseMsg = function (response) {
  let errorMsg = '';
  if (response) {
    if (Common.Util.isString(response) && response.indexOf(' - Error report</title>') > 0) {
      const getContent = function (startStr, endStr) {
        const posStart = response.indexOf(startStr);
        if (posStart > 0) {
          const posEnd = response.indexOf(endStr, posStart);
          if (posEnd > 0) {
            const content = response.substring(posStart + startStr.length, posEnd);
            return content;
          }
        }
        return '';
      };
      errorMsg = `错误标题：${getContent('<body><h1>', '</h1>')}\r\n`
        + `错误类型：${getContent('<p><b>type</b>', '</p>')
          .replace('<u>', '')}\r\n`
        + `错误消息：${getContent('<b>message</b>', '</u>')
          .replace('<u>', '')}\r\n`
        + `错误描述：${getContent('<b>description</b>', '</u>')
          .replace('<u>', '')}\r\n`;
    }
    if (Common.Util.isObject(response) && Common.Util.isString(response.message)) {
      errorMsg = response.message;
    }
  } else {
    errorMsg = '无法连接服务器';
  }
  if (errorMsg.startsWith('Network Error')) {
    errorMsg = '暂时无法连接服务器，请联系客服人员！';
  } else if (errorMsg.startsWith('timeout of ')) {
    errorMsg = '操作请求超时，请重试！';
  }
  return errorMsg;
};

/**
 * 成功获取下载数据后展现下载窗口
 * @param response
 */
service.showDownloadWindow = function (response) {
  let fileName = response.headers['content-disposition'];
  let contentType = response.headers['content-type'];
  contentType = contentType.split(';')[0];
  if (fileName) {
    fileName = fileName.substring(fileName.indexOf('filename=') + 10, fileName.length - 1);
    fileName = decodeURI(fileName);
    if (fileName.substring(fileName.length - 4) == 'xlsx') {
      contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (fileName.substring(fileName.length - 3) == 'xls') {
      contentType = 'application/vnd.ms-excel';
    }
  }

  const file = new Blob([response.data], {type: contentType});
  // 判断是不是Ie游览器
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    window.navigator.msSaveBlob(file, fileName);
  } else {
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = fileName;
    a.target = '_blank';
    a.click();
    a.remove();
  }
};

/**
 * 初始化请求头部类型及参数
 * @param config
 * @param contentType
 * @param urlData
 * @returns {*}
 */
service.initConfig = function (config, contentType, urlData) {
  if (!config) {
    config = {};
  }
  if (contentType) {
    config.headers = {};
    config.headers['Content-Type'] = `${contentType};charset=utf-8`;
  }
  if (urlData) {
    config.params = urlData;
  }
  return config;
};

/** 增加一个get请求用于直接请求文件流 */
service.getDownloadFile = function (vm, url, data, config) {
  return httpDownloadFile(vm, url, null, data, config, true);
};

/** 增加一个post请求用于直接请求文件流 */
service.postDownloadFile = function (vm, url, postData, urlData, config) {
  return httpDownloadFile(vm, url, postData, urlData, config, false);
};

/**  直接请求文件流, 不对外直接使用 */
// eslint-disable-next-line no-var
var httpDownloadFile = function (vm, url, postData, urlData, config, isGetMethod) {
  // eslint-disable-next-line no-var,no-redeclare
  var config = {};
  config.responseType = 'blob';
  config = service.initConfig(config, null, null);
  const deferred = jQuery.Deferred();
  let httpReq = null;
  url = service.beforeRequest(vm, url);
  url = Common.Request.beforeSend(vm, url, urlData);
  let headers = {};
  if (config) {
    config.headers = headers;
  } else {
    config = {};
    config.headers = headers;
  }
  if (isGetMethod) {
    httpReq = axios.get(service.serverUrl + url, config);
  } else {
    httpReq = axios.post(service.serverUrl + url, postData, config);
  }
  httpReq.then((response) => {
    service.showDownloadWindow(response);
    deferred.resolve('系统已处理');
  }, (response) => {
    const errorMsg = service.getFailedResponseMsg(response);
    Common.PageOperator.showPromptMsg(vm, true, errorMsg, 'error');
    deferred.reject(errorMsg);
  });
  return deferred.promise();
};

/**  Before Send the request filter **/
service.beforeRequest = function (vm, url, urlData) {
  url = Common.Request.beforeSend(vm, url, urlData);
  return url;
};

/**  After Send the request filter **/
service.afterRequest = function (vm, url, postData, promise) {
  const deferred = jQuery.Deferred();
  promise.then((response) => {
    const handleResult = Common.Request.afterResponse(vm, response.data, url, postData);
    if (handleResult != 'abort') {
      deferred.resolve(handleResult);
    } else {
      if (url.indexOf('/yqy-auth/enterprise_user/current_user') < 0) {
        deferred.reject(response);
      }
    }
  }, (response) => {
    const errorMsg = service.getFailedResponseMsg(response);
    console.log(errorMsg);
    //TODO
    // Common.PageOperator.showPromptMsg(vm, true, errorMsg, 'error');
    // deferred.reject(errorMsg);
  });
  return deferred.promise();
};

/**
 *
 * @param vm
 * @param url
 * @param postData
 * @param urlData
 */
service.postForm = function (vm, url, urlData, postData) {
  const promise = axios.post(url, postData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Credentials': true,
    },
  });
  return service.afterRequest(vm, url, postData, promise);
};

/**
 *
 * @param vm
 * @param url
 * @param postData
 * @param urlData
 */
service.postFile = function (vm, url, urlData, postData) {
  url = service.beforeRequest(vm, url, urlData);
  const promise = axios.post(url, postData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Credentials': true,
    },
  });
  return service.afterRequest(vm, url, postData, promise);
};

/**
 *
 * @param vm
 * @param url
 * @param postData
 * @param urlData
 * @param config
 */
service.post = function (vm, url, postData, urlData, config) {
  var baseUrl = window.SERVER_BASE;
  return service.handlePost(vm, url, postData, urlData, config,baseUrl);
};

service.brcPost = function (vm, url, postData, urlData, config) {
  var baseUrl = window.SERVER_BRC_BASE;
  return service.handlePost(vm, url, postData, urlData, config,baseUrl);
};

service.handlePost = function(vm, url, postData, urlData, config,baseUrl){
  url = service.beforeRequest(vm, url, urlData);
  if (!config) {
    config = {};
  }
  url = baseUrl+url;
  const promise = axios.post(url, postData, config);
  return service.afterRequest(vm, url, postData, promise);
};

/**
 *
 * @param vm
 * @param url
 * @param urlData
 */
service.get = function (vm, url, urlData) {
  var baseUrl = window.SERVER_BASE;
  return service.handleGet(vm, url, urlData,baseUrl);
};
service.brcGet = function (vm, url, urlData) {
  var baseUrl = window.SERVER_BRC_BASE;
  return service.handleGet(vm, url, urlData,baseUrl);
};
service.handleGet = function(vm, url, urlData,baseUrl){
  url = service.beforeRequest(vm, url, urlData);
  let headers = {};
  let config = {};
  url = baseUrl+url;
  const promise = axios.get(url, config);
  return service.afterRequest(vm, url, null, promise);
};

/**
 *
 * @param vm
 * @param url
 * @param urlData
 */
service.delete = function (vm, url, urlData) {
  url = service.beforeRequest(vm, url, urlData);
  let headers = {};
  const promise = axios.delete(url, {
    headers,
  });
  return service.afterRequest(vm, url, null, promise);
};

// eslint-disable-next-line no-unused-vars
const errorCodeMsg = {
  0: '无法连接服务器，服务已停止',
  400: '错误的请求',
  401: '访问被拒绝',
  403: '禁止访问',
  404: '服务未找到或服务已停止',
  405: '用来访问本页面的 HTTP 谓词不被允许（方法不被允许）',
  406: '客户端浏览器不接受所请求页面的 MIME 类型',
  407: '要求进行代理身份验证',
  412: '前提条件失败',
  413: '请求实体太大',
  414: '请求 URI 太长',
  415: '不支持的媒体类型',
  416: '所请求的范围无法满足',
  417: '执行失败',
  423: '锁定的错误',
};

export default service;



// WEBPACK FOOTER //
// ./src/api/APIService.js